export default __webpack_public_path__ + "static/media/bg4.28da0936.png";